<div class="pt-3">
  <app-order-search-form [form]="form" [loading]="loading" (onSubmit)="onSubmit()"></app-order-search-form>

  <div *ngIf="isAllOrdersView" class="text-center">
    <p class="text-primary cursor-pointer" (click)="resetOrders()">{{ 'SEARCH.RESET' | translate }}</p>
  </div>
</div>

<h5 *ngIf="!loading && hasOrderOptions" class="text-center mb-3 mt-5">
  {{ 'OVERVIEW.SEARCH_VIEW' | translate }} {{ orders.length }} {{ 'OVERVIEW.SEARCH_ORDERS' | translate }}
</h5>

<app-orders-table *ngIf="isAllOrdersView" [loading]="loading" [orders]="orders" (onOrderClick)="onOrderClick($event)"></app-orders-table>

<ng-template #unavailableOrderModal>
  <div class="modal-body">
    <h4 class="mb-3">{{ 'UNAVAILABLE_ORDER_MODAL.TITLE' | translate }}</h4>

    <p>{{ 'UNAVAILABLE_ORDER_MODAL.TEXT_1' | translate }}</p>

    <p>
      {{ 'UNAVAILABLE_ORDER_MODAL.TEXT_2' | translate }}
      <a href="https://extranet.airtrade.com" target="_blank">Extranet</a>.
    </p>

    <div class="text-right">
      <button type="button" class="btn btn-primary" (click)="modalRef.hide()">
        {{ 'GENERAL.MODAL_OK' | translate }}
      </button>
    </div>
  </div>
</ng-template>
